import {ICandle} from '../../types/resources/Candle';
import Panel from '../Panel';
import styled from 'styled-components';
import CandleIcon from './CandleIcon';

const CandleWrapper = styled.div`
    svg {
      height: 65px;
    }
`;

type TProps = {
    candle: ICandle;
}

const CandleCard = ({candle}: TProps) => {
    return (
        <Panel className={'cr-candle'} center={true}>
            <div className="cr-flex cr-flex-col cr-gap cr-center cr-candle">
                <CandleWrapper className="cr-candle-icon cr-text-icon">
                    <CandleIcon type={candle.mediaUrl}/>
                </CandleWrapper>
                <div className="cr-candle-name cr-text-alert cr-text-center">{candle.authorName}</div>
            </div>
        </Panel>
    );
}

export default CandleCard;
